import React, {
  useEffect,
} from 'react';

import {
  useLocation,
} from 'react-router-dom';

import {
  useStore,
} from '../../store';

import {
  userColumns,
} from '../../utils/columns';

import {
  DataTable,
} from '../../components';

export function User() {
  const location = useLocation();

  const {
    user,
  } = useStore();

  useEffect(() => {
    if( location.pathname === '/users')
      user.loadUsers();

  }, [ location ]);

  return (
    <DataTable
      title="Usuário"
      columns={ userColumns }
      store={ user }
    />
  );
};
